import React from "react";
import styled from "@emotion/styled";

const StyledDiv = styled.div`
  /* border: 2px solid purple; */

  min-height: calc(100vh - 4rem);
  margin-top: 4rem;
  box-sizing: border-box;
  background-color: #fcfcfc;

  .image {
    width: 200px;
    margin: 3rem auto 1.2rem auto;
  }

  .page-header {
    /* border: 2px solid lightblue; */
    font-family: "Roboto";
    font-weight: 500;
    font-size: 1.8rem;
    margin: 0 auto 1rem auto;

    .header-bold {
      color: #00a5e0;
    }
  }

  .sub-header {
    /* border: 2px solid magenta; */
    font-size: medium;
    font-weight: 500;
    font-family: "Roboto";
    margin: 0 auto;
    width: 60%;
  }
`;

const IMG_SRC = "https://uploads-ssl.webflow.com/606f59a06712dbd97ef84dee/6100fb5a2eb5c48b5d5dccb9_gif-vini%20(1).gif";

const ErrorPage: React.FC<{ message?: string }> = ({ message }) => {
  return (
    <StyledDiv>
      <div className="content-container">
        <img className="image" src={IMG_SRC} />
        <h3 className="page-header">{message || "Você está na página errada!"}</h3>
      </div>
    </StyledDiv>
  );
};

export default ErrorPage;
